<template>
  <div class="login-pos">
    <img class="login-pos__logo" src="@/assets/images/header/logo.png"/>
    <div class="login-pos__transaction-success">
      Transaction Successful
    </div>
    <div class="login-pos__button-login">
      <b-button @click="handleNewTransaction">New Transaction</b-button>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    handleNewTransaction() {
      this.$router.push('/lotto');
    }
  }
}
</script>
